/* Conscious Items Menu V3 (full arm). Intelligems onsite injection. Source and README: conscious-items/menu-v3/injection */
(function () {
'use strict';
/*
  SALE EVENT SLOT (edit here, run `node build.js`, resend both V3 variations).

  enabled  true shows the bright card at the top of the phone drawer and a
           colored first label in the desktop menu, until endsAt.
  title    short line in small capitals on the card, and the desktop label.
           Leave empty to show no small-capitals line (then set label).
  subtitle the main line on the card.
  terms    optional small line under the main line, e.g. a minimum spend.
  label    optional desktop label text; defaults to title.
  note     optional third line. Leave empty to show "Ends today",
           "Ends Sunday" or "Ends Sep 21", worked out from endsAt.
  href     store path without the leading slash, e.g. 'collections/on-sale'.
  endsAt   US Eastern wall time, 'YYYY-MM-DD HH:MM'. After this moment the
           card and label hide themselves, even on an open page.
  offerDialog  true makes the desktop label open the store's offer dialog
           (#ci-offer-modal, "How it works") instead of following href.
           Only for the offer that dialog explains; false for other sales.

  img, price, was, line  Menu B v2 drawer, "b2" sale card (optional, SORTED arm only). When img
           AND price are both non-empty the sorted-arm phone drawer card renders as a slim card
           with a product photo and a live countdown; otherwise the plain card above renders
           unchanged. The V3 arm always renders the plain card and ignores these four fields.
  img      product photo for the card, CDN path like the IMG map entries ('files/...').
  price    main line, e.g. 'Bracelets $7.36'.
  was      struck price shown next to the main line. Leave empty for none.
  line     sub line under the main line. Leave empty for none.
           The countdown pill reads endsAt: HH:MM:SS under 24 hours, 'Xd HHh' above, and
           hides itself at zero (the card itself is governed by endsAt as before).

  QA preview: add ?civ3sale=1 to any store URL in a V3 arm. It forces the
  slot on for that page view only and does nothing else.
*/
/*
  OFFER LABEL SLOT (edit here, run `node build.js`).

  The drawer offer row and the desktop offer label both show this text. They
  are NOT the SALE block above: they are the entry points to the store's
  "How it works" dialog (snippets/ci-offer-explainer.liquid, rendered from
  sections/header.liquid), and applySlots keeps them hidden unless that dialog
  is on the page AND some non-v3 trigger exists. So they go on and off with
  the dialog, never on their own.

  Empty while no offer is running (2026-10-12 teardown). It previously held
  the label of the 2026-10-02 sitewide sale, which had been expired since
  10-05 while the string still shipped on every page. Set it in the SAME
  change that restores the dialog, to the SAME offer the dialog explains, and
  clear it in the same change that switches the dialog off.
*/
var OFFER_LABEL = '';

var SALE = {
  enabled: false,
  title: '',
  subtitle: '',
  terms: '',
  label: '',
  note: '',
  href: 'collections/popular-items',
  endsAt: '',
  offerDialog: false,
  img: '',
  price: '',
  was: '',
  line: ''
};

/*
  GIFTS DESKTOP LABEL SLOT (edit here, run `node build.js`, resend both V3 variations).

  enabled   true shows a seventh desktop label, dated, between startsAt and endsAt.
  label     the desktop label text.
  startsAt  US Eastern wall time, 'YYYY-MM-DD HH:MM'. Before this moment the
            label stays hidden, even on an open page.
  endsAt    US Eastern wall time, 'YYYY-MM-DD HH:MM'. After this moment the
            label hides itself, even on an open page.

  QA preview: add ?civ3gifts=1 to any store URL in a V3 arm. It forces the
  label on for that page view only and does nothing else.
*/
var GIFTS = {
  enabled: true,
  label: 'Gifts',
  startsAt: '2026-11-01 00:00',
  endsAt: '2026-12-24 23:59'
};
/* true after the test ships; Ondrej approved Gifts 3rd Nov 1 to Dec 24. While false the sorted drawer keeps the out-of-season Gifts row all year. */
var DRAWER_GIFTS_MOVE = false;
/* b2 card approved, tested separately after this test. While false the sorted arm renders the same plain sale card as v3. */
var SALE_B2 = false;
if (window.__civ3) return;
var ARM = 'full';
window.__civ3 = ARM;
/*
  ARM (dual build, 2026-10-22). One asset holds two phone drawers.
  'v3'      today's drawer, markup unchanged. The default.
  'sorted'  the sorted drawer (Trending and Shop by intention strips, reordered rows).
  arm is 'sorted' only when the URL has civ3arm=sorted (QA, that page view only) or
  window.__civ3Arm === 'sorted'. civ3arm=v3 forces v3. Anything else is 'v3'. The URL flag beats
  window.__civ3Arm. Set window.__civ3Arm BEFORE this file runs, or call
  window.__civ3SetArm('v3' | 'sorted') after it ran: if the drawer is built and closed it is
  rebuilt at once, if it is open the switch applies after the next close. Safe to repeat.
  Desktop is identical in both arms. Without a URL flag and without window.__civ3Arm the arm cached in
  localStorage 'ci_nav_arm' ('<arm>|<epoch ms>', written whenever the arm comes from window.__civ3Arm or
  __civ3SetArm) is used while it is under 12 hours old. nav_open key src says where the arm came from:
  'url' (civ3arm flag), 'ig' (window.__civ3Arm or SetArm), 'ls' (cache), 'def' (default v3).

  TRACKING (both arms): Triple Whale custom events through TriplePixel('custom', name, data),
  queued (max 200) until window.TriplePixel is a function. Payloads are flat, at most 10 keys,
  strings at most 100 chars. Every event carries arm ('v3'|'sorted') and d ('m' phone drawer,
  'd' desktop menu). Events: nav_open, nav_impr, nav_tap, nav_close, nav_ret, nav_err.
  Sections (sec): s sale card, t trending strip, k V3 category tiles, i intention tiles,
  p V3 chips, r rows and panel buttons, c crystal swatches, g gifts panel, z zodiac panel,
  j jewelry panel (V3), h crystals and home panel (V3), a section header links (Shop all, See all),
  q search results, o other drawer links (login, service, reviews). Desktop sec is the menu label
  key (best, jewelry, home, intentions, crystal, gifts, sale, offer). No PII, no cookies,
  no network call other than TriplePixel. When a QA URL flag (civ3arm, civ3sale, civ3gifts) is present every
  event also carries qa:1. Events that cannot be sent (no TriplePixel yet) are kept in the queue and, on
  pagehide / hidden, written to sessionStorage 'ci_nav_q' and drained at the next script start.
  Navigation-bound events (nav_tap, the nav_impr flush right before it, nav_close how=nav) of a tap on a
  same-origin link that will navigate (not a panel button, not target=_blank, no modifier key) are NOT sent on the
  dying page (the browser cancels the in-flight call): they are stored in sessionStorage 'ci_nav_q' with dfr:1 and
  sent by the next page's queue drain. If the page is still here 5 s later they are sent at once with dfr:2.
*/
var ARM_SRC = 'def';
function readArmCache() {
try {
var v = String(window.localStorage.getItem('ci_nav_arm') || '').split('|');
var t = parseInt(v[1], 10);
if ((v[0] === 'v3' || v[0] === 'sorted') && t > 0 && Date.now() - t >= 0 && Date.now() - t < 43200000) return v[0];
} catch (e) {  }
return '';
}
function writeArmCache(a) {
try { window.localStorage.setItem('ci_nav_arm', a + '|' + Date.now()); } catch (e) {  }
}
function resolveArm() {
var m = /(^|[?&])civ3arm=(sorted|v3)(&|$)/.exec(location.search.slice(1));
if (m) { ARM_SRC = 'url'; return m[2]; }
var w = window.__civ3Arm;
if (w !== undefined && w !== null && w !== '') {
var a = w === 'sorted' ? 'sorted' : 'v3';
ARM_SRC = 'ig';
writeArmCache(a);
return a;
}
var c = readArmCache();
if (c) { ARM_SRC = 'ls'; return c; }
ARM_SRC = 'def';
return 'v3';
}
function qaOn() {
return /(^|[?&])(civ3arm|civ3sale|civ3gifts)=/.test(location.search.slice(1));
}
var arm = resolveArm();
function now() {
return (window.performance && performance.now) ? performance.now() : Date.now();
}
var TW_Q = [];
var TW_D = [];
var TW_DEF = 0;
var TW_LEFT = false;
var TW_WROTE = false;
var twTimer = 0;
var twTries = 0;
function twDrain() {
if (typeof window.TriplePixel !== 'function') {
while (TW_Q.length > 200) TW_Q.shift();
return false;
}
var sent = TW_Q.length > 0;
while (TW_Q.length) {
var x = TW_Q.shift();
try { window.TriplePixel('custom', x[0], x[1]); } catch (e) {  }
}
if (sent) twSync();
return true;
}
function twKick() {
if (twDrain() || twTimer || !TW_Q.length) return;
twTimer = setInterval(function () {
twTries += 1;
if (twDrain() || twTries > 120) {
clearInterval(twTimer);
twTimer = 0;
twTries = 0;
}
}, 1000);
}
function twClean(d) {
var o = {};
var n = 0;
for (var k in d) {
if (!Object.prototype.hasOwnProperty.call(d, k) || n >= 10) continue;
var v = d[k];
if (typeof v === 'number') { if (!isFinite(v)) v = 0; }
else if (typeof v !== 'boolean') v = String(v).slice(0, 100);
o[k] = v;
n += 1;
}
return o;
}
function tw(name, data) {
try {
if (qaOn()) data.qa = 1;
if (TW_DEF) {
data.dfr = 1;
TW_D.push([name, twClean(data)]);
while (TW_D.length > 200) TW_D.shift();
twSync();
return;
}
TW_Q.push([name, twClean(data)]);
if (!twDrain()) twKick();
} catch (e) {  }
}
function twSync() {
try {
var it = (typeof window.TriplePixel === 'function' ? [] : TW_Q).concat(TW_D);
if (!it.length) { if (TW_WROTE) { TW_WROTE = false; window.sessionStorage.removeItem('ci_nav_q'); } }
else { TW_WROTE = true; window.sessionStorage.setItem('ci_nav_q', JSON.stringify(it.slice(-200))); }
} catch (e) {  }
}
function twPersist() {
twSync();
}
function twUndefer() {
if (TW_LEFT || !TW_D.length) return;
var a = TW_D;
TW_D = [];
for (var i = 0; i < a.length; i++) { a[i][1].dfr = 2; TW_Q.push(a[i]); }
twSync();
if (!twDrain()) twKick();
}
function navBound(el, ev) {
try {
if (!el || el.tagName !== 'A') return false;
if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0)) return false;
if (String(el.getAttribute('target') || '').toLowerCase() === '_blank') return false;
if (el.hasAttribute('download') || el.hasAttribute('data-ci-offer-open')) return false;
var h = el.getAttribute('href');
if (!h || /^\s*(#|javascript:|mailto:|tel:)/i.test(h)) return false;
var u = new URL(el.href, location.href);
if (u.origin !== location.origin) return false;
if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
return true;
} catch (e) { return false; }
}
function twRestore() {
try {
var raw = window.sessionStorage.getItem('ci_nav_q');
if (!raw) return;
window.sessionStorage.removeItem('ci_nav_q');
var a = JSON.parse(raw);
if (!Array.isArray(a)) return;
var out = [];
for (var i = 0; i < a.length; i++) {
if (a[i] && typeof a[i][0] === 'string' && /^nav_/.test(a[i][0]) && a[i][1] && typeof a[i][1] === 'object') out.push([a[i][0], twClean(a[i][1])]);
}
TW_Q = out.slice(-200).concat(TW_Q);
twSync();
twKick();
} catch (e) {  }
}
twRestore();
function rnd6() {
var c = 'abcdefghijklmnopqrstuvwxyz0123456789';
var s = '';
for (var i = 0; i < 6; i++) s += c.charAt(Math.floor(Math.random() * 36));
return s;
}
function lastSeg(href) {
try {
var p = new URL(String(href || ''), location.href).pathname.split('/').filter(Boolean);
return (p.length ? p[p.length - 1] : '').slice(0, 40);
} catch (e) {
return '';
}
}
var TK = { open: false, oid: '', arm: 'v3', src: 'def', at: 0, taps: 0, maxy: 0, seen: 0, pend: [], io: null, map: null, flushT: 0, hint: '', hintAt: 0, intentAt: 0, root: null, watched: false };
var DKT = { pid: '', taps: 0, at: 0 };
var SUBSEC = { gifts: 'g', zodiac: 'z', jewelry: 'j', crystals: 'h' };
var IMPR = { s: 1, t: 1, k: 1, i: 1, p: 1, c: 1, r: 1, g: 1, z: 1, j: 1, h: 1 };
function secOfMain(el) {
if (el.closest('.civ3-search-wrap')) return 'q';
if (el.closest('.civ3-evt')) return 's';
if (el.closest('.civ3-h')) return 'a';
if (el.closest('.civ3-chip')) return 'p';
if (el.closest('.civ3-stone')) return 'c';
var sec = el.closest('.civ3-sec');
if (sec && el.closest('.civ3-tile')) {
if (sec.classList.contains('civ3-sec--trend')) return 't';
var hd = sec.querySelector('.civ3-h a');
return String(hd ? hd.getAttribute('href') : '').indexOf('by-intention') >= 0 ? 'i' : 'k';
}
if (el.closest('.civ3-rows')) return 'r';
return 'o';
}
function keyOf(el) {
if (el.tagName === 'BUTTON') return String(el.getAttribute('aria-controls') || '').replace('civ3-sub-', '').slice(0, 40);
return lastSeg(el.getAttribute('href'));
}
/* Every trackable element of the open drawer, in DOM order, with its section and 1-based position inside it. */
function tkIndex() {
var list = [];
var cnt = {};
var roots = doc.querySelectorAll('#menu-drawer .civ3-dr, #menu-drawer .civ3-sub');
for (var r = 0; r < roots.length; r++) {
var root = roots[r];
var sub = root.classList.contains('civ3-sub') ? root : null;
var subSec = sub ? (SUBSEC[sub.id.replace('civ3-sub-', '')] || 'o') : '';
var els = root.querySelectorAll('a[href], button[data-civ3-panel]');
for (var i = 0; i < els.length; i++) {
var el = els[i];
if (el.closest('[hidden]')) continue;
var sec = sub ? subSec : secOfMain(el);
cnt[sec] = (cnt[sec] || 0) + 1;
list.push({ el: el, sec: sec, pos: cnt[sec], key: keyOf(el), sub: sub, seen: false, t: 0 });
}
}
return list;
}
function tkSeen(it) {
if (!TK.open || it.seen) return;
if (it.sub && !it.sub.classList.contains('is-open')) return;
it.seen = true;
TK.seen += 1;
TK.pend.push(it.sec + ':' + it.pos + ':' + it.key);
}
function tkFlush() {
if (!TK.pend.length) return;
var items = TK.pend;
TK.pend = [];
var chunks = [];
var cur = '';
for (var i = 0; i < items.length; i++) {
if (cur && cur.length + 1 + items[i].length > 100) { chunks.push(cur); cur = ''; }
cur = cur ? cur + '|' + items[i] : items[i];
}
if (cur) chunks.push(cur);
var per = qaOn() ? 5 : 6;
for (var c = 0; c < chunks.length; c += per) {
var d = { arm: TK.arm, d: 'm', oid: TK.oid };
for (var j = 0; j < per && c + j < chunks.length; j++) d['i' + (j + 1)] = chunks[c + j];
tw('nav_impr', d);
}
}
function tkStop() {
if (TK.io) { try { TK.io.disconnect(); } catch (e) {  } }
if (TK.map) TK.map.forEach(function (it) { if (it.t) { clearTimeout(it.t); it.t = 0; } });
TK.io = null;
TK.map = null;
if (TK.flushT) clearInterval(TK.flushT);
TK.flushT = 0;
}
function tkObserve() {
if (typeof IntersectionObserver !== 'function' || typeof Map !== 'function') return;
var idx = tkIndex();
TK.map = new Map();
TK.io = new IntersectionObserver(function (ents) {
for (var i = 0; i < ents.length; i++) {
var it = TK.map && TK.map.get(ents[i].target);
if (!it) continue;
if (ents[i].isIntersecting && ents[i].intersectionRatio >= 0.5) {
if (!it.seen && !it.t) (function (x) { x.t = setTimeout(function () { x.t = 0; tkSeen(x); }, 500); })(it);
} else if (it.t) {
clearTimeout(it.t);
it.t = 0;
}
}
}, { root: null, threshold: [0.5] });
for (var k = 0; k < idx.length; k++) {
if (!IMPR[idx[k].sec]) continue;
TK.map.set(idx[k].el, idx[k]);
TK.io.observe(idx[k].el);
}
}
function tkOpen() {
if (TK.open) return;
TK.open = true;
TK.oid = rnd6();
TK.arm = arm;
TK.src = DR.src || ARM_SRC;
TK.at = now();
TK.taps = 0;
TK.maxy = 0;
TK.seen = 0;
TK.pend = [];
TK.hint = '';
TK.root = doc.querySelector('#menu-drawer .civ3-dr');
var intent = TK.intentAt;
TK.intentAt = 0;
var oid = TK.oid;
var a = TK.arm;
var src = TK.src;
var announced = false;
function announce(late) {
if (announced) return;
announced = true;
var lat = (intent && late !== true) ? Math.round(now() - intent) : -1;
tw('nav_open', { arm: a, d: 'm', oid: oid, sale: saleOn() ? 1 : 0, gifts: giftsOn() ? 1 : 0, w: window.innerWidth, lat: lat, src: src });
try {
var t = parseInt(window.sessionStorage.getItem('civ3_tap_at'), 10);
var s = (Date.now() - t) / 1000;
if (t > 0 && s >= 0 && s <= 60) tw('nav_ret', { arm: a, d: 'm', s: Math.round(s) });
} catch (e) {  }
}
try { if (window.requestAnimationFrame) window.requestAnimationFrame(function () { announce(false); }); } catch (e) {  }
setTimeout(function () { announce(true); }, 1000);
tkObserve();
TK.flushT = setInterval(tkFlush, 5000);
}
function tkClose(how) {
if (!TK.open) return;
tkFlush();
TK.open = false;
var h = how;
if (!h) h = (TK.hint && now() - TK.hintAt < 1500) ? TK.hint : 'other';
tw('nav_close', { arm: TK.arm, d: 'm', oid: TK.oid, tapped: TK.taps > 0 ? 1 : 0, ms: Math.round(now() - TK.at), maxy: TK.maxy, how: h });
TK.hint = '';
tkStop();
}
function trackWatch(h) {
if (TK.watched || typeof MutationObserver !== 'function') return;
TK.watched = true;
new MutationObserver(function () {
if (h.det.hasAttribute('open')) tkOpen(); else tkClose();
}).observe(h.det, { attributes: true, attributeFilter: ['open'] });
doc.addEventListener('menudrawer:close', function () { tkClose(); });
window.addEventListener('pageshow', function (e) {
if (e && e.persisted && h.det.hasAttribute('open') && !TK.open) tkOpen();
});
}
function tkTap(el, ev) {
var it = null;
var idx = tkIndex();
for (var i = 0; i < idx.length; i++) if (idx[i].el === el) { it = idx[i]; break; }
if (!it) it = { sec: el.closest('.civ3-search-wrap') ? 'q' : 'o', pos: 0, key: keyOf(el) };
var nb = navBound(el, ev);
if (nb) TW_DEF = 1;
try {
tkFlush();
TK.taps += 1;
var panel = el.tagName === 'BUTTON';
tw('nav_tap', { arm: TK.arm, d: 'm', oid: TK.oid, sec: it.sec, pos: it.pos, key: it.key, first: TK.taps === 1 ? 1 : 0, ms: Math.round(now() - TK.at) });
if (panel || el.hasAttribute('data-ci-offer-open')) return;
try { window.sessionStorage.setItem('civ3_tap_at', String(Date.now())); } catch (e) {  }
if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0)) return;
tkClose('nav');
} finally {
TW_DEF = 0;
if (nb) setTimeout(twUndefer, 5000);
}
}
function tkDeskTap(el, ev) {
var li = el.closest('li');
var sec = 'o';
if (li) {
if (li.classList.contains('civ3-dk-sale')) sec = 'sale';
else if (li.classList.contains('civ3-dk-offer')) sec = 'offer';
else if (li.getAttribute('data-ci-nav-label')) sec = li.getAttribute('data-ci-nav-label').replace(/^v3-/, '');
}
var pos = 0;
var mega = el.closest('.civ3-mega');
if (mega) pos = Array.prototype.indexOf.call(mega.querySelectorAll('a[href]'), el) + 1;
if (!DKT.pid) DKT.pid = rnd6();
DKT.taps += 1;
var nb = navBound(el, ev);
if (nb) TW_DEF = 1;
try {
tw('nav_tap', { arm: arm, d: 'd', oid: DKT.pid, sec: sec, pos: pos, key: el.tagName === 'BUTTON' ? sec : lastSeg(el.getAttribute('href')), first: DKT.taps === 1 ? 1 : 0, ms: DK && DK.open ? Math.round(now() - DKT.at) : 0 });
} finally {
TW_DEF = 0;
if (nb) setTimeout(twUndefer, 5000);
}
}
function tkClick(e) {
try {
var t = e.target;
if (!t || !t.closest) return;
if (TK.open) {
if (t.closest('summary.header__icon--menu, drawer-close-button, button[data-close]')) { TK.hint = 'x'; TK.hintAt = now(); }
else if (!t.closest('header-drawer')) { TK.hint = 'bg'; TK.hintAt = now(); }
}
var el = t.closest('#menu-drawer a[href], #menu-drawer button[data-civ3-panel]');
if (el && TK.open && el.closest('.civ3')) { tkTap(el, e); return; }
var dk = t.closest('.civ3-dk a[href], .civ3-dk button');
if (dk) tkDeskTap(dk, e);
} catch (err) {  }
}
function tkScroll(e) {
var t = e.target;
if (!TK.open || !t || t.nodeType !== 1 || !TK.root || !t.contains(TK.root)) return;
var y = Math.round(t.scrollTop);
if (y > TK.maxy) TK.maxy = y;
}
window.addEventListener('click', tkClick, { capture: true, passive: true });
window.addEventListener('scroll', tkScroll, { capture: true, passive: true });
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { tkFlush(); twPersist(); twKick(); } else twSync(); });
window.addEventListener('pagehide', function () { TW_LEFT = true; tkFlush(); twPersist(); });
window.addEventListener('pageshow', function (e) { if (e && e.persisted) { TW_LEFT = false; TW_D = []; twSync(); } });
function trackErr(part, message) {
tw('nav_err', { arm: arm, d: /^desktop/.test(part) ? 'd' : 'm', part: String(part).slice(0, 40), msg: String(message).slice(0, 100) });
}
var HOST_ERR = {};
function hostMissing(part, selectors) {
if (HOST_ERR[part]) return;
var miss = '';
for (var i = 0; i < selectors.length; i++) if (!document.querySelector(selectors[i])) { miss = selectors[i]; break; }
if (!miss) return;
HOST_ERR[part] = 1;
trackErr(part, miss + ' missing');
}
var DRAWER_SEL = ['sticky-header header-drawer, header-drawer', 'header-drawer details', 'header-drawer #menu-drawer', 'header-drawer .menu-drawer__inner-container', 'header-drawer .menu-drawer__navigation-container'];
var DESKTOP_SEL = ['sticky-header nav.header__inline-menu'];
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { if (!DR.built && !drawerHost()) hostMissing('drawer-host', DRAWER_SEL); });
var STONES = [
['amethyst', 'Amethyst', 'Calm', 'collections/amethyst'],
['rose', 'Rose Quartz', 'Love', 'collections/rose-quartz'],
['tourmaline', 'Black Tourmaline', 'Protection', 'collections/black-tourmaline-jewelry'],
['selenite', 'Selenite', 'Cleansing', 'collections/selenite'],
['citrine', 'Citrine', 'Abundance', 'collections/citrine'],
['moonstone', 'Moonstone', 'Intuition', 'collections/moonstone'],
['tiger', "Tiger's Eye", 'Confidence', 'collections/tigers-eye'],
['obsidian', 'Black Obsidian', 'Grounding', 'collections/black-obsidian-jewelry'],
['clear', 'Clear Quartz', 'Clarity', 'collections/clear-quartz'],
['malachite', 'Malachite', 'Growth', 'collections/malachite'],
['labradorite', 'Labradorite', 'Transformation', 'collections/labradorite-jewelry'],
['lapis', 'Lapis Lazuli', 'Wisdom', 'collections/lapis-lazuli-jewelry']
];
var INTENTS = [
['Protection', 'Protection', 'collections/protection-and-support', 'tourmaline', 'Black Tourmaline, Obsidian', 'obsidian', 'tiger', 28],
['Abundance & Luck', 'Abundance & Luck', 'collections/wealth-and-abundance', 'citrine', "Citrine, Tiger's Eye", 'tiger', 'malachite', 6],
['Calm, Stress & Sleep', 'Calm, Stress & Sleep', 'collections/anxiety-stress-relief', 'amethyst', 'Amethyst, Moonstone', 'moonstone', 'clear', 18],
['Love', 'Love', 'collections/love-and-happiness', 'rose', 'Rose Quartz, Rhodonite', 'rhodonite', 'amethyst', 14],
['Manifestation', 'Manifestation', 'collections/success-and-manifestation', 'clear', 'Clear Quartz, Citrine', 'citrine', 'selenite', 18],
['Self Care', 'Self Care', 'collections/self-care-and-confidence', 'moonstone', 'Moonstone, Rose Quartz', 'rose', 'selenite', 32],
['Focus & Energy', 'Focus', 'collections/balance-and-focus', 'tiger', "Tiger's Eye, Carnelian", 'carnelian', 'citrine', 21],
['New Beginnings', 'New Beginnings', 'collections/change-and-new-beginnings', 'labradorite', 'Labradorite, Moonstone', 'moonstone', 'obsidian', 29],
['Healing & Cleansing', 'Healing', 'collections/healing-and-cleansing', 'selenite', 'Selenite, Clear Quartz', 'clear', 'malachite', 31]
];
var ZODIAC = [
['Aries', 'Mar 21 to Apr 19', 'aries-collection'], ['Taurus', 'Apr 20 to May 20', 'taurus-collection'],
['Gemini', 'May 21 to Jun 20', 'gemini-collection'], ['Cancer', 'Jun 21 to Jul 22', 'cancer-collection'],
['Leo', 'Jul 23 to Aug 22', 'leo-collection'], ['Virgo', 'Aug 23 to Sep 22', 'virgo-collection'],
['Libra', 'Sep 23 to Oct 22', 'libra-collection'], ['Scorpio', 'Oct 23 to Nov 21', 'scorpio-collection'],
['Sagittarius', 'Nov 22 to Dec 21', 'sagittarius-collection'], ['Capricorn', 'Dec 22 to Jan 19', 'capricorn-jewelry'],
['Aquarius', 'Jan 20 to Feb 18', 'aquarius-collection'], ['Pisces', 'Feb 19 to Mar 20', 'pisces-collection']
];
var IMG = {
'p-cord-cutter': ['files/Copyofee71f6ea12b9899089cadfaa7dbc3989_1787557287784-w_1.jpg?v=1789380086', 274, 318, 638],
'p-amethyst-lamp-glow': ['files/i-am-at-peace-spiritual-protection-amethyst-lamp-8956847.jpg?v=1751600716', 128, 206, 788],
'p-arfvedsonite-pendant': ['files/image_40b703a6ccfdb5990129f0b46e8cdbcd-w_1.jpg?v=1789380328', 138, 294, 906],
'p-calm': ['files/Lifestyle-4_1_275d9eb3-63ee-419b-8573-0ba7769457df.jpg?v=1784535540', 282, 268, 642],
'p-triple-protection-bracelet': ['products/the-triple-protection-bracelet-7785560.jpg?v=1762197916'],
'p-abundance': ['files/the-hypersthene-millionaire-manifestation-bracelet-4223950.jpg?v=1762199056'],
'p-black-moonstone': ['files/DSC00083-w-2_1.jpg?v=1774252993'],
'p-amethyst-lamp': ['files/i-am-at-peace-spiritual-protection-amethyst-lamp-6862602.jpg?v=1762198511'],
'p-cleanse-all': ['files/the-cleanse-all-selenite-lamp-2-pounds-of-healing-power-2832992.jpg?v=1762198891'],
't-healing-necklace': ['collections/necklaces-pendants-4073117.jpg?v=1751600710'],
't-anklets': ['files/the-energy-shield-anklet-1019314.jpg?v=1762198175'],
't-rings': ['collections/rings-8341586.jpg?v=1751600725'],
't-healing-crystal-lamps': ['collections/4_56c9896c-7846-460e-bfa1-2051e7611ec9.png?v=1780647918'],
't-crystals-for-car-protection': ['collections/car-crystals-1701024.jpg?v=1751600686'],
't-home': ['collections/home-decor-4914952.jpg?v=1751600628'],
't-gifts-for-her': ['files/cosmic-energy-amplifier-galaxy-tigers-eye-bracelet-4442951.jpg?v=1762199025'],
't-gifts-for-dad': ['files/manifest-success-clear-quartz-lamp-of-achievement-7057864.jpg?v=1762198797'],
't-gifts-for-the-jewelry-lover': ['files/born-to-thrive-copper-bracelet-of-power-5752830.jpg?v=1762198626'],
't-zodiac-sets': ['collections/zodiac-sets-4470260.jpg?v=1751600742'],
't-brand-new-arrivals': ['collections/2_be10f14a-6115-41db-81ec-abc481e1f8f0.png?v=1780647700'],
't-crystal-cleansing': ['collections/crystal-cleansing-7754344.jpg?v=1751600616'],
't-carvings-pyramids': ['products/rose-quartz-love-apples-8104802.jpg?v=1762197970'],
't-crystals': ['collections/7_2e25889c-aae1-4593-a028-d025bc8f5498.png?v=1780648098'],
'p-mahogany-bracelet': ['files/DSC00717-e-3_1.jpg?v=1783330703'],
'p-seraphinite-pendants': ['files/DSC00635-w_2.jpg?v=1783319920'],
'p-hypersthene-bracelet': ['files/the-hypersthene-millionaire-manifestation-bracelet-4223950.jpg?v=1762199056'],
'c-crystal-lamps': ['files/Untitled_design_2_5797f5f0-ac65-450d-8a10-bad3e9967d02.png?v=1789726667'],
'c-car-crystals': ['files/Untitled_design_4_6316d530-1973-4392-8bba-19b88d220a61.png?v=1789726809'],
'c-home-decor': ['files/Untitled_design_7_29318046-1b42-4429-9bbb-7c45a74112b6.png?v=1789726981'],
'c-bracelets': ['files/Untitled_design_3_9706b00f-7676-41fb-86a1-c5ed983e7c5f.png?v=1789726666'],
'c-necklaces': ['files/Untitled_design_1_63f3f81f-a49c-4807-bfa0-b0d8d6651ce7.png?v=1789726667'],
'c-protection': ['files/DSC00083-2-2_2_1.jpg?v=1789717158'],
'c-abundance': ['files/Untitled_design_e183c3de-e2d5-4c77-9ba2-162b5dd1d04a.png?v=1789726667'],
'c-calm': ['files/Copy_of_DSC00161_1_1.jpg?v=1789717160'],
'c-anklets': ['collections/anklets-7290043.jpg?v=1751600680'],
'c-rings': ['collections/rings-8341586.jpg?v=1751600725'],
'i-love': ['files/exotic-orca-agate-bracelet-of-deep-healing-4775210.jpg?v=1762198911'],
'i-manifest': ['files/DSC01335-w_1.jpg?v=1791196294'],
'i-selfcare': ['files/empaths-shield-aqua-terra-jasper-bracelet-2371052.jpg?v=1762199193'],
'i-focus': ['files/DSC01256-e-W_1.jpg?v=1791960252'],
'i-healing': ['files/the-arfvedsonite-deep-healing-pendant-conscious-items-6494825.jpg?v=1765249931'],
'i-newbegin': ['files/the-quadruple-protection-bracelet-1328174.jpg?v=1762198946'],
'c-crystals-all': ['collections/7_2e25889c-aae1-4593-a028-d025bc8f5498.png?v=1780648098']
};
var PROD = {
tpb: ['triple-protection-bracelet', 'The Triple Protection Bracelet', 'p-triple-protection-bracelet'],
bm: ['black-moonstone', "The Empath's Cord Cutter Black Moonstone Bracelet", 'p-black-moonstone'],
al: ['amethyst-lamp', 'I Am At Peace Amethyst Lamp', 'p-amethyst-lamp'],
ca: ['cleanse-all', 'The Cleanse-All Selenite Lamp', 'p-cleanse-all'],
mb: ['mahogany-bracelet', 'The Self-Sabotage Breaker Mahogany Obsidian Bracelet', 'p-mahogany-bracelet'],
sp: ['seraphinite-pendants', 'By My Side - Rare Seraphinite Pendant', 'p-seraphinite-pendants'],
hb: ['hypersthene-bracelet', 'The Hypersthene Millionaire Manifestation Bracelet', 'p-hypersthene-bracelet']
};
var doc = document;
var html = doc.documentElement;
var ROOT = '/';
function marketRoot() {
var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
return typeof r === 'string' && r.charAt(0) === '/' ? r : '/';
}
function esc(s) {
return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function A(path, inner, cls) {
return '<a href="' + esc(ROOT + path) + '"' + (cls ? ' class="' + cls + '"' : '') + '>' + inner + '</a>';
}
var IC = {
search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
user: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
chev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>',
back: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6"/></svg>'
};
function glyph(i) {
return String.fromCharCode(0x2648 + i) + '\uFE0E';
}
var WIDTHS = [120, 180, 240, 360, 480, 720];
function imgUrl(key, w) {
var d = IMG[key];
var crop = d.length > 1 ? '&crop=region&crop_left=' + d[1] + '&crop_top=' + d[2] + '&crop_width=' + d[3] + '&crop_height=' + d[3] : '';
return '/cdn/shop/' + d[0] + crop + '&width=' + w;
}
function media(key, sizes) {
return '<span class="civ3-media"><img alt="" decoding="async" data-civ3-img="' + key + '" sizes="' + sizes + '"></span>';
}
function hydrate(scope, force) {
if (!scope) return;
var list = scope.querySelectorAll('img[data-civ3-img]');
for (var i = 0; i < list.length; i++) {
var im = list[i];
if (!force && im.closest('[role="tabpanel"][hidden]')) continue;
var key = im.getAttribute('data-civ3-img');
im.removeAttribute('data-civ3-img');
if (!IMG[key]) continue;
im.srcset = WIDTHS.map(function (w) { return imgUrl(key, w) + ' ' + w + 'w'; }).join(', ');
im.src = imgUrl(key, 360);
}
}
var priceReq = {};
function money(cents) {
var out = '';
try {
var t = window.theme;
if (t && t.Currency && t.Currency.formatMoney && t.shopSettings && t.shopSettings.moneyFormat) {
out = String(t.Currency.formatMoney(cents, t.shopSettings.moneyFormat)).replace(/<[^>]*>/g, '');
}
} catch (e) { out = ''; }
if (!out) {
try {
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
out = new Intl.NumberFormat(html.lang || 'en', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(Math.round(cents / 100));
} catch (e2) { out = ''; }
}
return out;
}
function fillPrices(scope) {
var list = scope.querySelectorAll('[data-civ3-price]');
Array.prototype.forEach.call(list, function (el) {
var handle = el.getAttribute('data-civ3-price');
el.removeAttribute('data-civ3-price');
if (!priceReq[handle]) {
priceReq[handle] = fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
.then(function (r) { return r.ok ? r.json() : null; })
.catch(function () { return null; });
}
priceReq[handle].then(function (p) {
if (!p || typeof p.price !== 'number') return;
var now = money(p.price);
if (!now) return;
var was = typeof p.compare_at_price === 'number' && p.compare_at_price > p.price ? money(p.compare_at_price) : '';
var onSale = !!(was && was !== now);
el.classList.toggle('civ3-price--sale', onSale);
el.innerHTML = esc(now) + (onSale ? '<s>' + esc(was) + '</s>' : '');
});
});
}
function easternOffset(ms) {
try {
var p = {};
new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
return Date.UTC(+p.year, p.month - 1, +p.day, +p.hour % 24, +p.minute) - Math.floor(ms / 60000) * 60000;
} catch (e) {
return -4 * 3600000;
}
}
function easternToMs(s) {
var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(s || '').trim());
if (!m) return NaN;
var wall = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
var t = wall - easternOffset(wall);
return wall - easternOffset(t);
}
var SALE_END = easternToMs(SALE.endsAt);
var SALE_QA = /(^|[?&])civ3sale=1(&|$)/.test(location.search.slice(1));
var GIFTS_START = easternToMs(GIFTS.startsAt);
var GIFTS_END = easternToMs(GIFTS.endsAt);
var GIFTS_QA = /(^|[?&])civ3gifts=1(&|$)/.test(location.search.slice(1));
function saleOn() {
return SALE_QA || (SALE.enabled === true && SALE_END > Date.now());
}
function giftsOn() {
return GIFTS_QA || (GIFTS.enabled === true && Date.now() >= GIFTS_START && GIFTS_END > Date.now());
}
function saleNote() {
if (SALE.note) return SALE.note;
if (!(SALE_END > 0)) return '';
try {
var tz = { timeZone: 'America/New_York' };
var day = function (ms) { return new Intl.DateTimeFormat('en-CA', tz).format(new Date(ms)); };
var left = SALE_END - Date.now();
if (left > 0 && day(SALE_END) === day(Date.now())) return 'Ends today';
if (left > 0 && left < 6 * 86400000) return 'Ends ' + new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long' }).format(new Date(SALE_END));
return 'Ends ' + new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric' }).format(new Date(SALE_END));
} catch (e) {
return '';
}
}
function applySlots() {
var on = saleOn();
var list = doc.querySelectorAll('[data-civ3-sale]');
for (var i = 0; i < list.length; i++) list[i].hidden = !on;
var giftsOnNow = giftsOn();
var giftsList = doc.querySelectorAll('[data-civ3-gifts]');
for (var j = 0; j < giftsList.length; j++) giftsList[j].hidden = !giftsOnNow;
if (DR.arm === 'sorted') {
var seasonList = doc.querySelectorAll('[data-civ3-gifts-season]');
for (var m = 0; m < seasonList.length; m++) seasonList[m].hidden = (seasonList[m].getAttribute('data-civ3-gifts-season') === 'in') !== (DRAWER_GIFTS_MOVE && giftsOnNow);
/* The Gifts twins swap on the season boundary: renumber the visible main rows 1..n and drop the number from hidden ones. */
var mainRows = doc.querySelectorAll('.civ3-dr .civ3-rows > .civ3-row:not(.civ3-row--offer)');
var rowNo = 0;
for (var q = 0; q < mainRows.length; q++) {
if (mainRows[q].hidden) mainRows[q].removeAttribute('data-civ3-row');
else mainRows[q].setAttribute('data-civ3-row', String(rowNo += 1));
}
/* An open Gifts submenu keeps its opener: if that button just got hidden, hand it to the visible twin. */
if (DR && DR.sub && DR.opener && DR.opener.hidden) {
var twin = doc.querySelector('.civ3-dr button[data-civ3-panel][aria-controls="' + DR.opener.getAttribute('aria-controls') + '"]:not([hidden])');
if (twin) {
twin.setAttribute('aria-expanded', DR.opener.getAttribute('aria-expanded') || 'true');
DR.opener.setAttribute('aria-expanded', 'false');
DR.opener = twin;
}
}
}
var offerOn = !!doc.getElementById('ci-offer-modal') &&
!!doc.querySelector('[data-ci-offer-open]:not([data-ci-offer-open^="v3-"])');
var offerList = doc.querySelectorAll('[data-civ3-offer]');
for (var k = 0; k < offerList.length; k++) {
var barOnly = offerList[k].hasAttribute('data-civ3-offer-bar');
offerList[k].hidden = !offerOn || (barOnly && on);
}
}
function whenReady(test, cb) {
if (test()) { cb(); return; }
if (doc.readyState !== 'loading') { cb(); return; }
var done = false;
var finish = function () {
if (done) return;
done = true;
mo.disconnect();
cb();
};
var mo = new MutationObserver(function () { if (test()) finish(); });
mo.observe(html, { childList: true, subtree: true });
doc.addEventListener('DOMContentLoaded', finish);
}
function guard(fn, part, onFail) {
return function () {
try {
return fn.apply(this, arguments);
} catch (e) {
window.__civ3Error = { part: part, message: String((e && e.message) || e) };
try { trackErr(part, window.__civ3Error.message); } catch (e3) {  }
try { if (onFail) onFail(); } catch (e2) {  }
return false;
}
};
}
var DR = { built: false, waiting: false, md: null, body: null, sub: null, opener: null, arm: '', pend: false, failed: false, bound: false };
var SIZES_TILE3 = '(min-width: 750px) 170px, calc((100vw - 102px) / 3)';
var SIZES_TILE2 = '(min-width: 750px) 260px, calc((100vw - 92px) / 2)';
var SIZES_CARD = '(min-width: 750px) 190px, calc((100vw - 82px) * 0.36)';
function drawerHost() {
var hd = doc.querySelector('sticky-header header-drawer') || doc.querySelector('header-drawer');
var det = hd && hd.querySelector('details');
var md = hd && hd.querySelector('#menu-drawer');
var inner = md && md.querySelector('.menu-drawer__inner-container');
var nav = inner && inner.querySelector('.menu-drawer__navigation-container');
return nav && det ? { hd: hd, det: det, md: md, inner: inner, nav: nav } : null;
}
function drawerReady() {
return !!doc.querySelector('sticky-header .header__heading, sticky-header .header__right, sticky-header header-menu-toggle');
}
function drTop(h) {
var acc = h.md.querySelector('.menu-drawer__account');
var accHref = acc && acc.getAttribute('href') ? acc.getAttribute('href') : ROOT + 'account';
var accText = acc && acc.textContent.replace(/\s+/g, ' ').trim() ? acc.textContent.replace(/\s+/g, ' ').trim() : 'Log in';
return '<div class="civ3-bar"><a class="civ3-login" href="' + esc(accHref) + '">' + IC.user + '<span>' + esc(accText) + '</span></a></div>';
}
function drSearch() {
return '<div class="civ3-search-wrap" data-civ3-search-mount></div>';
}
function drSearchFallback() {
return '<form class="civ3-search search-modal__form" role="search" action="' + esc(ROOT + 'search') + '" method="get">' +
'<input type="search" name="q" placeholder="Search crystals, bracelets, lamps" autocomplete="off" enterkeyhint="search" aria-label="Search">' +
'<input type="hidden" name="type" value="product">' +
'<button type="submit" class="civ3-search-go" aria-label="Search">' + IC.search + '</button>' +
'</form>';
}
var SEARCH_ID_SUFFIX = '-civ3';
var SEARCH_REF_ATTRS = ['for', 'aria-owns', 'aria-controls', 'aria-labelledby', 'aria-describedby'];
function suffixSearchIds(root, suffix) {
suffix = suffix || SEARCH_ID_SUFFIX;
var map = {}, i, j, el, oldId, newId;
var idEls = root.querySelectorAll('[id]');
for (i = 0; i < idEls.length; i++) {
el = idEls[i];
oldId = el.id;
if (!oldId || oldId.slice(-1 * suffix.length) === suffix) continue;
newId = oldId + suffix;
map[oldId] = newId;
el.id = newId;
}
var refEls = root.querySelectorAll('[for],[aria-owns],[aria-controls],[aria-labelledby],[aria-describedby]');
for (i = 0; i < refEls.length; i++) {
el = refEls[i];
for (j = 0; j < SEARCH_REF_ATTRS.length; j++) {
var val = el.getAttribute(SEARCH_REF_ATTRS[j]);
if (val && map[val]) el.setAttribute(SEARCH_REF_ATTRS[j], map[val]);
}
}
}
function guardMenuDrawerClose(input) {
if (!input) return;
var HD = (typeof customElements === 'undefined') ? null : (customElements.get('header-drawer') || customElements.get('menu-drawer'));
var proto = HD && HD.prototype;
if (!proto || !proto.onBodyClick || proto.__civ3Patched) return;
var orig = proto.onBodyClick;
proto.onBodyClick = function (e) {
if (doc.activeElement === input) return;
return orig.apply(this, arguments);
};
proto.__civ3Patched = true;
}
function mountSearchClone(wrap) {
try {
if (typeof customElements === 'undefined' || !customElements.get('predictive-search')) return false;
var src = doc.querySelector('predictive-search');
if (!src) return false;
var clone = src.cloneNode(true);
clone.removeAttribute('open');
clone.removeAttribute('loading');
clone.removeAttribute('results');
var form = clone.querySelector('form.search');
if (!form) return false;
form.classList.add('civ3-search');
form.classList.add('search-modal__form');
var input = clone.querySelector('input[type="search"]');
if (input) input.setAttribute('placeholder', 'Search crystals, bracelets, lamps');
suffixSearchIds(clone);
wrap.appendChild(clone);
wrap.addEventListener('focusout', function (e) { e.stopPropagation(); });
guardMenuDrawerClose(input);
var results = clone.querySelector('[data-predictive-search]');
if (results && typeof MutationObserver !== 'undefined') {
new MutationObserver(function () { suffixSearchIds(clone); }).observe(results, { childList: true, subtree: true });
}
clone.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && clone.hasAttribute('open')) {
e.stopPropagation();
if (typeof clone.close === 'function') clone.close(true);
}
});
return true;
} catch (e) {
return false;
}
}
function trySearchMount(wrap, attempt) {
if (mountSearchClone(wrap)) return;
if (attempt >= 20) { wrap.innerHTML = drSearchFallback(); return; }
setTimeout(function () { trySearchMount(wrap, attempt + 1); }, 250);
}
var SALE_CLOCK = { timer: 0, end: 0 };
function clockPad(n) {
return (n < 10 ? '0' : '') + n;
}
function clockText(ms) {
var d = Math.max(0, Math.floor(ms / 1000));
if (d >= 86400) return Math.floor(d / 86400) + 'd ' + clockPad(Math.floor(d % 86400 / 3600)) + 'h';
return clockPad(Math.floor(d / 3600)) + ':' + clockPad(Math.floor(d / 60) % 60) + ':' + clockPad(d % 60);
}
function stopSaleClock() {
if (SALE_CLOCK.timer) clearInterval(SALE_CLOCK.timer);
SALE_CLOCK.timer = 0;
}
function tickSaleClock() {
var box = doc.querySelector('.civ3-evt--b2 [data-civ3-clock]');
if (!box) { stopSaleClock(); return; }
var left = SALE_CLOCK.end - Date.now();
if (!(left > 0)) { box.hidden = true; stopSaleClock(); return; }
var t = box.querySelector('[data-civ3-clock-t]');
var txt = clockText(left);
if (t && t.textContent !== txt) t.textContent = txt;
box.hidden = false;
}
function startSaleClock() {
stopSaleClock();
if (!doc.querySelector('.civ3-evt--b2 [data-civ3-clock]') || !saleOn()) return;
var end = SALE_END;
/* QA only: with ?civ3sale=1 and an endsAt that is past or empty, count down to now + 3 hours so the clock can be seen in preview. */
if (SALE_QA && !(end > Date.now())) end = Date.now() + 3 * 3600000;
if (!(end > Date.now())) return;
SALE_CLOCK.end = end;
tickSaleClock();
if (SALE_CLOCK.timer === 0 && SALE_CLOCK.end > Date.now()) SALE_CLOCK.timer = setInterval(tickSaleClock, 1000);
}
function saleImgUrl(w) {
return '/cdn/shop/' + SALE.img + (SALE.img.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
}
function drEventB2() {
return '<a class="civ3-evt civ3-evt--b2" href="' + esc(ROOT + SALE.href) + '" data-civ3-sale hidden>' +
'<img class="civ3-evb-img" alt="" width="52" height="52" decoding="async" src="' + esc(saleImgUrl(120)) + '" srcset="' + esc(saleImgUrl(120)) + ' 120w, ' + esc(saleImgUrl(240)) + ' 240w" sizes="52px">' +
'<span class="civ3-evb-mid"><span class="civ3-evb-p">' + esc(SALE.price) + (SALE.was ? '<s>' + esc(SALE.was) + '</s>' : '') + '</span>' +
(SALE.line ? '<span class="civ3-evb-s">' + esc(SALE.line) + '</span>' : '') + '</span>' +
'<span class="civ3-evb-clock" role="timer" data-civ3-clock hidden><span class="civ3-evb-t" data-civ3-clock-t></span><span class="civ3-evb-l">left</span></span></a>';
}
function drEvent() {
if (SALE_B2 && DR.arm === 'sorted' && SALE.img && SALE.price) return drEventB2();
var note = saleNote();
return '<a class="civ3-evt" href="' + esc(ROOT + SALE.href) + '" data-civ3-sale hidden><span class="civ3-evt-t">' + (SALE.title ? '<em>' + esc(SALE.title) + '</em>' : '') + '<b>' + esc(SALE.subtitle) + '</b>' +
(SALE.terms ? '<small>' + esc(SALE.terms) + '</small>' : '') +
(note ? '<small>' + esc(note) + '</small>' : '') + '</span><span class="civ3-evt-go" aria-hidden="true">' + IC.chev + '</span></a>';
}
function drHead(title, path, linkText) {
return '<div class="civ3-h"><span>' + esc(title) + '</span>' + A(path, esc(linkText)) + '</div>';
}
function drTile(label, path, img, sizes, pos) {
var a = A(path, media(img, sizes) + '<span class="civ3-tile-t">' + esc(label) + '</span>', 'civ3-tile');
return pos ? a.replace('<a ', '<a data-civ3-pos="' + pos + '" ') : a;
}
function drPair(a, b, c) {
return '<span class="civ3-pair" aria-hidden="true"><i class="civ3-s-' + a + '"></i><i class="civ3-s-' + b + '"></i>' +
(c ? '<i class="civ3-s-' + c + '"></i>' : '') + '</span>';
}
function drPanelButton(cls, label, id, chev) {
return '<button type="button" class="' + cls + '" data-civ3-panel aria-expanded="false" aria-controls="civ3-sub-' + id + '"><span>' + esc(label) + '</span>' + (chev ? IC.chev : '') + '</button>';
}
function drSub(id, title, inner) {
return '<section class="civ3 civ3-sub" id="civ3-sub-' + id + '" aria-label="' + esc(title) + '" data-ci-nav-root>' +
'<div class="civ3-sub-head"><button type="button" class="civ3-back" data-civ3-back aria-label="Back">' + IC.back + '</button><b>' + esc(title) + '</b></div>' +
inner + '</section>';
}
function drZodiac() {
return '<div class="civ3-zod">' + ZODIAC.map(function (z, i) {
return A('collections/' + z[2], '<span class="civ3-g" aria-hidden="true">' + glyph(i) + '</span><b>' + esc(z[0]) + '</b><span class="civ3-zd">' + esc(z[1]) + '</span>');
}).join('') + '</div>';
}
function drService() {
return '<hr class="civ3-band"><div class="civ3-svc">' +
A('pages/conscious-rewards', 'Conscious Rewards') + A('a/track', 'Track my order') +
A('pages/help-center', 'Help center') + A('pages/contact-us', 'Contact us') + '</div>';
}
function buildDrawer() {
if (DR.built) return true;
var h = drawerHost();
if (!h) {
if (doc.readyState !== 'loading') hostMissing('drawer-host', DRAWER_SEL);
return false;
}
if (h.det.hasAttribute('open')) {
if (!DR.waiting) {
DR.waiting = true;
doc.addEventListener('menudrawer:close', function retry() {
setTimeout(function () {
if (h.det.hasAttribute('open')) return;
doc.removeEventListener('menudrawer:close', retry);
DR.waiting = false;
guardedBuildDrawer();
}, 450);
});
}
return false;
}
ROOT = marketRoot();
arm = resolveArm();
DR.arm = arm;
DR.src = ARM_SRC;
var main = '<div class="civ3 civ3-dr civ3-dr--' + ARM + '" data-ci-nav-root data-animate data-animate-delay-1>' + drTop(h) +
'<div class="civ3-body">' + drawerMain() + '</div></div>';
var subs = drawerSubs();
h.nav.insertAdjacentHTML('beforeend', main);
h.inner.insertAdjacentHTML('beforeend', subs);
var searchWrap = h.nav.querySelector('.civ3-search-wrap[data-civ3-search-mount]');
if (searchWrap) trySearchMount(searchWrap, 0);
DR.md = h.md;
DR.body = h.nav.querySelector('.civ3-dr .civ3-body');
bindDrawer(h);
html.classList.add('civ3-dr-on');
if (arm === 'sorted') html.classList.add('civ3-sorted');
applySlots();
startSaleClock();
DR.built = true;
return true;
}
function removeDrawer() {
stopSaleClock();
html.classList.remove('civ3-dr-on');
html.classList.remove('civ3-sorted');
var list = doc.querySelectorAll('#menu-drawer .civ3');
for (var i = 0; i < list.length; i++) list[i].parentNode.removeChild(list[i]);
DR.body = null;
}
function undoDrawer() {
removeDrawer();
DR.built = true;
DR.failed = true;
}
/* Arm switch: rebuild the drawer for the arm resolveArm() now returns. Only while the drawer is closed. */
function swapDrawer() {
DR.pend = false;
if (DR.sub) closeSub(false);
removeDrawer();
DR.built = false;
DR.waiting = false;
DR.arm = '';
guardedBuildDrawer();
}
function applyArm() {
var want = resolveArm();
if (!DR.built || DR.failed) { if (!DR.built) arm = want; return; }
if (want === DR.arm) { DR.pend = false; return; }
var h = drawerHost();
if (h && h.det.hasAttribute('open')) { DR.pend = true; return; }
swapDrawer();
}
window.__civ3SetArm = function (a) {
if (a !== 'v3' && a !== 'sorted') return false;
window.__civ3Arm = a;
writeArmCache(a);
try { applyArm(); } catch (e) { return false; }
return true;
};
doc.addEventListener('menudrawer:close', function () {
if (!DR.pend) return;
setTimeout(function () { if (DR.pend) { try { applyArm(); } catch (e) {  } } }, 500);
});
var guardedBuildDrawer = guard(buildDrawer, 'drawer', undoDrawer);
function openSub(btn) {
var sub = doc.getElementById(btn.getAttribute('aria-controls'));
if (!sub) return;
if (DR.sub && DR.sub !== sub) closeSub(false);
hydrate(sub);
sub.scrollTop = 0;
sub.classList.add('is-open');
btn.setAttribute('aria-expanded', 'true');
DR.sub = sub;
DR.opener = btn;
if (DR.body) DR.body.inert = true;
var back = sub.querySelector('[data-civ3-back]');
if (back) back.focus({ preventScroll: true });
}
function closeSub(returnFocus) {
var sub = DR.sub, btn = DR.opener;
if (!sub) return;
sub.classList.remove('is-open');
if (DR.body) DR.body.inert = false;
if (btn) btn.setAttribute('aria-expanded', 'false');
DR.sub = null;
DR.opener = null;
if (returnFocus && btn) btn.focus({ preventScroll: true });
}
function selectTab(tab, moveFocus) {
var tabs = tab.parentNode.querySelectorAll('[role="tab"]');
for (var i = 0; i < tabs.length; i++) {
var on = tabs[i] === tab;
tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
tabs[i].tabIndex = on ? 0 : -1;
var panel = doc.getElementById(tabs[i].getAttribute('aria-controls'));
if (!panel) continue;
panel.hidden = !on;
if (on) {
hydrate(panel);
var cards = panel.querySelector('.civ3-cards');
if (cards) cards.scrollLeft = 0;
}
}
if (moveFocus) tab.focus();
}
function bindDrawer(h) {
if (DR.bound) return;
DR.bound = true;
trackWatch(h);
h.md.addEventListener('click', function (e) {
var t = e.target;
if (!t || !t.closest) return;
var el;
if ((el = t.closest('[data-civ3-panel]'))) openSub(el);
else if ((el = t.closest('[data-civ3-back]'))) closeSub(true);
else if ((el = t.closest('.civ3 [role="tab"]'))) selectTab(el, false);
});
h.md.addEventListener('pointerdown', function (e) {
var t = e.target, el;
if (!t || !t.closest) return;
if ((el = t.closest('[data-civ3-panel], .civ3 [role="tab"]'))) hydrate(doc.getElementById(el.getAttribute('aria-controls')), true);
}, { passive: true });
h.md.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && DR.sub) {
e.stopPropagation();
closeSub(true);
}
});
h.md.addEventListener('keydown', function (e) {
var tab = e.target && e.target.closest && e.target.closest('.civ3 [role="tab"]');
if (!tab) return;
var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
var i = tabs.indexOf(tab), n = tabs.length, next = -1;
if (e.key === 'ArrowRight') next = (i + 1) % n;
else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
else if (e.key === 'Home') next = 0;
else if (e.key === 'End') next = n - 1;
if (next < 0) return;
e.preventDefault();
selectTab(tabs[next], true);
});
h.hd.addEventListener('close', function () {
setTimeout(function () { if (!h.det.hasAttribute('open')) closeSub(false); }, 450);
});
}
function hydrateDrawer() {
if (!DR.built || !DR.body) return;
hydrate(DR.body);
}
var SIZES_STRIP = '88px';
function drAttr(markup, attrs) {
return markup.replace(/^<(a|button) /, '<$1 ' + attrs + ' ');
}
function drawerMainSorted() {
var inSeason = DRAWER_GIFTS_MOVE && giftsOn();
function strip(list) {
return list.map(function (t, i) {
return drTile(t[0], t[1], t[2], SIZES_STRIP, i + 1);
}).join('');
}
var trending = strip([
['Bracelets', 'collections/bracelet', 'c-bracelets'],
['Necklaces', 'collections/healing-necklace', 'c-necklaces'],
['Crystal Lamps', 'collections/healing-crystal-lamps', 'c-crystal-lamps'],
['All Crystals', 'collections/crystals-all', 'c-crystals-all'],
['Rings', 'collections/rings', 't-rings'],
['Anklets', 'collections/anklets', 'c-anklets'],
['Car Crystals', 'collections/crystals-for-car-protection', 'c-car-crystals'],
['Home Decor', 'collections/home', 'c-home-decor']
]);
var intention = strip([
['Protection', 'collections/protection-and-support', 'c-protection'],
['Abundance & Luck', 'collections/wealth-and-abundance', 'c-abundance'],
['Calm & Sleep', 'collections/anxiety-stress-relief', 'c-calm'],
['Manifestation', 'collections/success-and-manifestation', 'i-manifest'],
['Love', 'collections/love-and-happiness', 'i-love'],
['Self Care', 'collections/self-care-and-confidence', 'i-selfcare'],
['Focus & Energy', 'collections/balance-and-focus', 'i-focus'],
['Healing', 'collections/healing-and-cleansing', 'i-healing'],
['New Beginnings', 'collections/change-and-new-beginnings', 'i-newbegin']
]);
var order = ['amethyst', 'tourmaline', 'tiger', 'obsidian', 'citrine', 'selenite', 'clear', 'rose', 'moonstone', 'malachite', 'labradorite', 'lapis'];
var stones = order.map(function (k) {
var s = STONES.filter(function (x) { return x[0] === k; })[0];
return A(s[3], '<i class="civ3-sw civ3-s-' + s[0] + '" aria-hidden="true"></i><b>' + esc(s[1]) + '</b><span>' + esc(s[2]) + '</span>', 'civ3-stone');
}).join('');
var n = 0;
function row(markup) { n += 1; return drAttr(markup, 'data-civ3-row="' + n + '"'); }
function giftsRow(slot) {
var show = (slot === 'in') === inSeason;
return drAttr(drPanelButton('civ3-row', 'Gifts', 'gifts', true), 'data-civ3-gifts-season="' + slot + '"' + (show ? ' data-civ3-row="' + (n += 1) + '"' : ' hidden'));
}
return drSearch() + drEvent() +
'<div class="civ3-sec civ3-sec--trend">' + drHead('Trending collections', 'collections/all-products-in-stock', 'Shop all') + '<div class="civ3-strip" data-civ3-strip>' +
trending +
'</div></div>' +
'<div class="civ3-sec">' + drHead('Shop by intention', 'pages/by-intention', 'See all') + '<div class="civ3-strip" data-civ3-strip>' +
intention +
'</div></div>' +
'<div class="civ3-rows">' +
'<a class="civ3-row civ3-row--offer" href="' + esc(ROOT + 'collections/popular-items') + '" data-ci-offer-open="v3-drawer" aria-haspopup="dialog" data-civ3-offer hidden>' +
'<span>' + esc(OFFER_LABEL) + '</span><span class="civ3-row-cue">How it works</span></a>' +
row(A('collections/popular-items', '<span>Best Sellers</span>' + IC.chev, 'civ3-row')) +
row(A('collections/on-sale', '<span>Sale</span>' + IC.chev, 'civ3-row')) +
giftsRow('in') +
row(A('collections/brand-new-arrivals', '<span>New Arrivals</span>' + IC.chev, 'civ3-row')) +
row(A('collections/jewelry', '<span>All Jewelry</span>' + IC.chev, 'civ3-row')) +
row(A('collections/crystals-all', '<span>Crystals & Home</span>' + IC.chev, 'civ3-row')) +
giftsRow('out') +
row(drPanelButton('civ3-row', 'Shop by Zodiac', 'zodiac', true)) +
'</div>' +
'<div class="civ3-sec">' + drHead('Shop by crystal', 'pages/by-crystal', 'See all') + '<div class="civ3-stones">' + stones + '</div></div>' +
drService() +
A('pages/all-reviews', '<span class="civ3-stars" aria-hidden="true">' + new Array(6).join(String.fromCharCode(0x2605)) + '</span><span>Rated 4.9 from 15,900+ reviews</span>', 'civ3-proof');
}
function drawerMainV3() {
var chips = ['Love', 'Manifestation', 'Self Care', 'Focus & Energy', 'New Beginnings'].map(function (label) {
var t = INTENTS.filter(function (x) { return x[0] === label; })[0];
return A(t[2], drPair(t[3], t[5]) + '<span>' + esc(t[1]) + '</span>', 'civ3-chip');
}).join('');
var stones = STONES.slice(0, 8).map(function (s) {
return A(s[3], '<i class="civ3-sw civ3-s-' + s[0] + '" aria-hidden="true"></i><b>' + esc(s[1]) + '</b><span>' + esc(s[2]) + '</span>', 'civ3-stone');
}).join('');
return drSearch() + drEvent() +
'<div class="civ3-sec">' + drHead('Shop by category', 'collections/all-products-in-stock', 'Shop all') + '<div class="civ3-tiles">' +
drTile('Bracelets', 'collections/bracelet', 'c-bracelets', SIZES_TILE3) +
drTile('Crystal Lamps', 'collections/healing-crystal-lamps', 'c-crystal-lamps', SIZES_TILE3) +
drTile('Necklaces', 'collections/healing-necklace', 'c-necklaces', SIZES_TILE3) +
'</div></div>' +
'<div class="civ3-sec">' + drHead('Shop by intention', 'pages/by-intention', 'See all') + '<div class="civ3-tiles">' +
drTile('Protection', 'collections/protection-and-support', 'c-protection', SIZES_TILE3) +
drTile('Abundance & Luck', 'collections/wealth-and-abundance', 'c-abundance', SIZES_TILE3) +
drTile('Calm, Stress & Sleep', 'collections/anxiety-stress-relief', 'c-calm', SIZES_TILE3) +
'</div><div class="civ3-chips">' + chips + '</div></div>' +
'<div class="civ3-sec">' + drHead('Shop by crystal', 'pages/by-crystal', 'See all') + '<div class="civ3-stones">' + stones + '</div></div>' +
'<div class="civ3-rows">' +
'<a class="civ3-row civ3-row--offer" href="' + esc(ROOT + 'collections/popular-items') + '" data-ci-offer-open="v3-drawer" aria-haspopup="dialog" data-civ3-offer hidden>' +
'<span>' + esc(OFFER_LABEL) + '</span><span class="civ3-row-cue">How it works</span></a>' +
A('collections/popular-items', '<span>Best Sellers</span>' + IC.chev, 'civ3-row') +
A('collections/brand-new-arrivals', '<span>New Arrivals</span>' + IC.chev, 'civ3-row') +
drPanelButton('civ3-row', 'All Jewelry', 'jewelry', true) +
drPanelButton('civ3-row', 'Crystals & Home', 'crystals', true) +
drPanelButton('civ3-row', 'Gifts', 'gifts', true) +
drPanelButton('civ3-row', 'Shop by Zodiac', 'zodiac', true) +
A('collections/on-sale', '<span>Sale</span>' + IC.chev, 'civ3-row') +
'</div>' +
drService() +
A('pages/all-reviews', '<span class="civ3-stars" aria-hidden="true">' + new Array(6).join(String.fromCharCode(0x2605)) + '</span><span>Rated 4.9 from 15,900+ reviews</span>', 'civ3-proof');
}
function fullRows(list) {
return '<div class="civ3-rows civ3-rows--flush">' + list.map(function (r) {
return A('collections/' + r[1], '<span>' + esc(r[0]) + '</span>' + IC.chev, 'civ3-row');
}).join('') + '</div>';
}
function drawerSubsSorted() {
return drSub('gifts', 'Gifts',
'<div class="civ3-tiles">' +
drTile('For Her', 'collections/gifts-for-her', 't-gifts-for-her', SIZES_TILE2) +
drTile('For Him', 'collections/gifts-for-dad', 't-gifts-for-dad', SIZES_TILE2) +
drTile('For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover', 't-gifts-for-the-jewelry-lover', SIZES_TILE2) +
drTile('Zodiac Gift Sets', 'collections/zodiac-sets', 't-zodiac-sets', SIZES_TILE2) +
'</div>' +
'<div class="civ3-rows civ3-rows--gap">' +
[['Gift bundles', 'bundles'], ['Gifts under $25', '0-25'], ['Gifts $25 to $35', '25-35'], ['Gifts $35 to $50', '35-50'], ['Gifts $50 to $75', '50-75']].map(function (r) {
return A('collections/' + r[1], '<span>' + esc(r[0]) + '</span>' + IC.chev, 'civ3-row');
}).join('') +
'</div>') +
drSub('zodiac', 'Shop by Zodiac',
drZodiac() + '<div class="civ3-rows">' + A('collections/zodiac-sets', '<span>Zodiac Gift Sets</span>' + IC.chev, 'civ3-row') + '</div>');
}
function drawerSubsV3() {
return drSub('gifts', 'Gifts',
'<div class="civ3-tiles">' +
drTile('For Her', 'collections/gifts-for-her', 't-gifts-for-her', SIZES_TILE2) +
drTile('For Him', 'collections/gifts-for-dad', 't-gifts-for-dad', SIZES_TILE2) +
drTile('For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover', 't-gifts-for-the-jewelry-lover', SIZES_TILE2) +
drTile('Zodiac Gift Sets', 'collections/zodiac-sets', 't-zodiac-sets', SIZES_TILE2) +
'</div>' +
'<div class="civ3-rows civ3-rows--gap">' +
[['Gift bundles', 'bundles'], ['Gifts under $25', '0-25'], ['Gifts $25 to $35', '25-35'], ['Gifts $35 to $50', '35-50'], ['Gifts $50 to $75', '50-75']].map(function (r) {
return A('collections/' + r[1], '<span>' + esc(r[0]) + '</span>' + IC.chev, 'civ3-row');
}).join('') +
'</div>') +
drSub('zodiac', 'Shop by Zodiac',
drZodiac() + '<div class="civ3-rows">' + A('collections/zodiac-sets', '<span>Zodiac Gift Sets</span>' + IC.chev, 'civ3-row') + '</div>') +
drSub('jewelry', 'All Jewelry', fullRows([
['Bracelets', 'bracelet'], ['Necklaces & Pendants', 'healing-necklace'], ['Anklets', 'anklets'], ['Rings', 'rings'],
['Demi-Fine Silver', 'demi-fine-silver-jewelry'], ['For Men', 'crystals-for-men'], ['Bracelet Sets', 'bracelet-sets'], ['Shop all jewelry', 'jewelry']
])) +
drSub('crystals', 'Crystals & Home', fullRows([
['Crystal Lamps', 'healing-crystal-lamps'], ['Car Crystals', 'crystals-for-car-protection'], ['Home Decor', 'home'], ['Crystal Cleansing', 'crystal-cleansing'],
['Carvings & Pyramids', 'carvings-pyramids'], ['Crystal Sets', 'crystals'], ['Shop all crystals', 'crystals-all']
]));
}
function drawerMain() {
return arm === 'sorted' ? drawerMainSorted() : drawerMainV3();
}
function drawerSubs() {
return arm === 'sorted' ? drawerSubsSorted() : drawerSubsV3();
}
var DK = { built: false, bar: null, items: [], open: null, openTimer: 0, closeTimer: 0, touchAt: 0, scrollY: 0 };
var SIZES_PCARD = '(min-width: 1440px) 260px, 18vw';
var SIZES_SQ = '(min-width: 1440px) 300px, 22vw';
function desktopReady() {
return !!doc.querySelector('sticky-header .header__right');
}
function dkLinks(title, items, extra) {
return '<div' + (extra ? ' class="' + extra + '"' : '') + '><div class="civ3-col-h">' + esc(title) + '</div><div class="civ3-links">' +
items.map(function (i) { return A(i[1], esc(i[0]), i[2] ? 'civ3-' + i[2] : ''); }).join('') + '</div></div>';
}
function dkCard(key, badge) {
var p = PROD[key];
return A('products/' + p[0], (badge ? '<span class="civ3-badge">' + esc(badge) + '</span>' : '') + media(p[2], SIZES_PCARD) +
'<span class="civ3-pname">' + esc(p[1]) + '</span><span class="civ3-price" data-civ3-price="' + p[0] + '"></span>', 'civ3-pcard');
}
function dkSquares(title, items, pills) {
return '<div><div class="civ3-col-h">' + esc(title) + '</div><div class="civ3-sqgrid">' +
items.map(function (i) {
return A(i[1], media(i[2], SIZES_SQ) + '<span>' + esc(i[0]) + '</span>', 'civ3-sq');
}).join('') + '</div>' +
(pills ? '<div class="civ3-pills civ3-pills--tight">' + pills.map(function (i) {
return A(i[1], esc(i[0]), 'civ3-pill' + (i[2] ? ' civ3-pill--all' : ''));
}).join('') + '</div>' : '') + '</div>';
}
var MEGAS = [
['Best Sellers', 'best', function () {
return dkLinks('Most loved', [['Shop all', 'collections/all-products-in-stock', 'all'], ['Best Sellers', 'collections/popular-items', 'all'], ['New Arrivals', 'collections/brand-new-arrivals'], ['Trending Now', 'collections/trending'], ['Back in Stock', 'collections/back-in-stock'], ['Sale', 'collections/on-sale']]) +
dkLinks('Gift ideas', [['For Her', 'collections/gifts-for-her'], ['For Him', 'collections/gifts-for-dad'], ['For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover'], ['Zodiac Gift Sets', 'collections/zodiac-sets'], ['Gift bundles', 'collections/bundles'], ['Gifts under $25', 'collections/0-25']]) +
dkCard('tpb', '#1 best seller') + dkCard('bm') + dkCard('al');
}],
['Jewelry', 'jewelry', function () {
return dkLinks('Jewelry', [['All Jewelry', 'collections/jewelry', 'all'], ['Bracelets', 'collections/bracelet'], ['Necklaces & Pendants', 'collections/healing-necklace'], ['Anklets', 'collections/anklets'], ['Rings', 'collections/rings'], ['Bracelet Sets', 'collections/bracelet-sets'], ['Demi-Fine Silver', 'collections/demi-fine-silver-jewelry'], ['For Men', 'collections/crystals-for-men']]) +
dkLinks('By intention', [['Protection', 'collections/protection-and-support'], ['Abundance & Luck', 'collections/wealth-and-abundance'], ['Calm, Stress & Sleep', 'collections/anxiety-stress-relief'], ['Love', 'collections/love-and-happiness'], ['Manifestation', 'collections/success-and-manifestation'], ['For Empaths', 'collections/crystals-jewelry-for-empaths']]) +
dkLinks('By crystal', [["Tiger's Eye", 'collections/tigers-eye'], ['Amethyst', 'collections/amethyst'], ['Black Obsidian', 'collections/black-obsidian-jewelry'], ['Rose Quartz', 'collections/rose-quartz'], ['Clear Quartz', 'collections/clear-quartz'], ['Moonstone', 'collections/moonstone'], ['Citrine', 'collections/citrine'], ['See all crystals', 'pages/by-crystal', 'all']]) +
dkCard('mb', 'Top rated') + dkCard('sp', 'Top necklace');
}],
['Lamps & Home', 'home', function () {
return dkSquares('Shop by category', [
['Crystal Lamps', 'collections/healing-crystal-lamps', 'c-crystal-lamps'],
['Car Crystals', 'collections/crystals-for-car-protection', 'c-car-crystals'],
['Home Decor', 'collections/home', 'c-home-decor'],
['Crystal Cleansing', 'collections/crystal-cleansing', 't-crystal-cleansing'],
['Carvings & Pyramids', 'collections/carvings-pyramids', 't-carvings-pyramids'],
['Crystal Sets', 'collections/crystals', 't-crystals']
], [['Shop all crystals', 'collections/crystals-all', 'all']]) +
dkCard('ca', 'Cleansing favorite');
}],
['Intentions', 'intentions', function () {
return '<div><div class="civ3-col-h">Shop by intention</div><div class="civ3-intgrid">' + INTENTS.map(function (t) {
return A(t[2], drPair(t[3], t[5], t[6]) + '<b>' + esc(t[0]) + '</b><span>' + esc(t[4]) +
(t[7] ? ' <span class="civ3-more">+ ' + t[7] + ' more</span>' : '') + '</span>');
}).join('') + '</div></div>' +
'<div><div class="civ3-col-h">By zodiac sign</div><div class="civ3-zmini">' + ZODIAC.map(function (z, i) {
return A('collections/' + z[2], '<span class="civ3-g" aria-hidden="true">' + glyph(i) + '</span>' + esc(z[0]));
}).join('') + '</div></div>' +
dkCard('hb', 'Abundance pick');
}],
['By Crystal', 'crystal', function () {
return '<div class="civ3-swgrid">' + STONES.map(function (s) {
return A(s[3], '<i class="civ3-sw civ3-s-' + s[0] + '" aria-hidden="true"></i><b>' + esc(s[1]) + '</b><span>' + esc(s[2]) + '</span>');
}).join('') + '</div>' +
'<div class="civ3-links civ3-links-inline">' + A('pages/by-crystal', 'See all crystals', 'civ3-all') + A('pages/crystals-and-their-meanings', 'Crystal meanings') + A('pages/quiz-best-crystal-for-me', 'Not sure? Take the crystal quiz') + '</div>';
}],
['Gifts', 'gifts', function () {
return dkSquares('Gift ideas', [
['For Her', 'collections/gifts-for-her', 't-gifts-for-her'],
['For Him', 'collections/gifts-for-dad', 't-gifts-for-dad'],
['For the Jewelry Lover', 'collections/gifts-for-the-jewelry-lover', 't-gifts-for-the-jewelry-lover'],
['Zodiac Gift Sets', 'collections/zodiac-sets', 't-zodiac-sets']
], [['Gift bundles', 'collections/bundles'], ['Under $25', 'collections/0-25'], ['$25 to $35', 'collections/25-35'], ['$35 to $50', 'collections/35-50'], ['$50 to $75', 'collections/50-75']]);
}, 'dated']
];
var DK_HREF = {
best: 'collections/popular-items',
jewelry: 'collections/jewelry',
home: 'collections/crystals-all',
intentions: 'pages/by-intention',
crystal: 'pages/by-crystal',
gifts: 'collections/gifts-for-her'
};
function desktopHTML() {
var out = '<div class="civ3 civ3-dk" data-ci-nav-root><ul class="civ3-dk-list" role="list">' +
'<li class="civ3-dk-offer" data-civ3-offer data-civ3-offer-bar hidden><a class="civ3-dk-label civ3-dk-label--offer" href="' + esc(ROOT + 'collections/popular-items') + '" data-ci-offer-open="v3-desktop" aria-haspopup="dialog">' +
'<span class="civ3-dk-offer__mark"><span>' + esc(OFFER_LABEL) + '</span><i class="civ3-dk-offer__cue" aria-hidden="true">?</i></span></a></li>' +
'<li class="civ3-dk-sale" data-civ3-sale hidden><a class="civ3-dk-label civ3-dk-label--sale" href="' + esc(ROOT + SALE.href) + '"' + (SALE.offerDialog === true ? ' data-ci-offer-open="v3-desktop-sale" aria-haspopup="dialog"' : '') + '><span>' + esc(SALE.label || SALE.title) + '</span></a></li>';
MEGAS.forEach(function (m) {
var key = m[1], label = m[0], content = m[2], dated = m[3] === 'dated';
if (typeof content === 'string') {
out += '<li class="civ3-dk-item civ3-dk-item--link" data-ci-nav-label="v3-' + key + '"><a class="civ3-dk-label" href="' + esc(ROOT + content) + '">' + esc(label) + '</a></li>';
return;
}
var liLabel = dated ? esc(GIFTS.label) : esc(label);
var href = DK_HREF[key];
var ctl = ' class="civ3-dk-label" aria-expanded="false" aria-controls="civ3-mega-' + key + '"';
out += '<li class="civ3-dk-item" data-ci-nav-label="v3-' + key + '"' + (dated ? ' data-civ3-gifts hidden' : '') + '>' +
(href ? '<a href="' + esc(ROOT + href) + '"' + ctl + '>' + liLabel + '</a>' : '<button type="button"' + ctl + '>' + liLabel + '</button>') +
'<div class="civ3-mega" id="civ3-mega-' + key + '" role="region" aria-label="' + liLabel + '" hidden><div class="civ3-mi civ3-mi--' + key + '">' + content() + '</div></div></li>';
});
return out + '</ul></div>';
}
var DKS_PLACEHOLDER = 'Search crystals, bracelets, lamps';
var DKS_ID_SUFFIX = '-civ3d';
function undoDesktopSearch() {
html.classList.remove('civ3-dks-on');
var wrap = doc.querySelector('sticky-header .header__left > .civ3-dks');
if (wrap) wrap.parentNode.removeChild(wrap);
}
function mountDesktopSearch() {
var wrap = null;
try {
var left = doc.querySelector('sticky-header .header__left');
var modal = left && left.querySelector(':scope > search-modal');
var src = modal && modal.querySelector('predictive-search');
if (!left || !modal || !src) return;
var clone = src.cloneNode(true);
clone.removeAttribute('open');
clone.removeAttribute('loading');
clone.removeAttribute('results');
var form = clone.querySelector('form.search');
if (!form) return;
var input = clone.querySelector('input[type="search"]');
if (input) {
input.setAttribute('placeholder', DKS_PLACEHOLDER);
input.setAttribute('aria-label', 'Search');
}
suffixSearchIds(clone, DKS_ID_SUFFIX);
var results = clone.querySelector('[data-predictive-search]');
if (results && typeof MutationObserver !== 'undefined') {
new MutationObserver(function () { suffixSearchIds(clone, DKS_ID_SUFFIX); }).observe(results, { childList: true, subtree: true });
}
clone.addEventListener('keyup', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && clone.hasAttribute('open')) {
e.stopPropagation();
if (typeof clone.close === 'function') clone.close(true);
}
});
wrap = doc.createElement('div');
wrap.className = 'civ3 civ3-dks';
wrap.appendChild(clone);
modal.insertAdjacentElement('afterend', wrap);
html.classList.add('civ3-dks-on');
} catch (e) {
undoDesktopSearch();
}
}
function buildDesktop() {
if (DK.built) return true;
var nav = doc.querySelector('sticky-header nav.header__inline-menu');
if (!nav) {
DK.built = true;
html.classList.add('civ3-dk-fail');
hostMissing('desktop-host', DESKTOP_SEL);
return false;
}
ROOT = marketRoot();
nav.insertAdjacentHTML('beforeend', desktopHTML());
DK.bar = nav.lastElementChild;
var lis = DK.bar.querySelectorAll('.civ3-dk-item');
for (var i = 0; i < lis.length; i++) {
var panel = lis[i].querySelector('.civ3-mega');
if (!panel) continue;
DK.items.push({ li: lis[i], btn: lis[i].querySelector('.civ3-dk-label'), panel: panel });
}
bindDesktop();
html.classList.add('civ3-dk-on');
try { mountDesktopSearch(); } catch (e) { undoDesktopSearch(); }
applySlots();
DK.built = true;
return true;
}
function undoDesktop() {
html.classList.remove('civ3-dk-on');
html.classList.add('civ3-dk-fail');
var bar = doc.querySelector('nav.header__inline-menu > .civ3-dk');
if (bar) bar.parentNode.removeChild(bar);
undoDesktopSearch();
DK.built = true;
DK.items = [];
DK.open = null;
}
function itemOf(el) {
for (var i = 0; i < DK.items.length; i++) if (DK.items[i].li === el || DK.items[i].li.contains(el)) return DK.items[i];
return null;
}
function warmMega(it) {
hydrate(it.panel);
fillPrices(it.panel);
}
function placeMega(it) {
var sh = doc.querySelector('sticky-header') || DK.bar;
var r = sh.getBoundingClientRect();
var b = DK.bar.getBoundingClientRect();
it.panel.style.left = (r.left - b.left) + 'px';
it.panel.style.width = r.width + 'px';
it.panel.style.top = (r.bottom - b.top) + 'px';
it.panel.style.maxHeight = Math.max(240, Math.round(window.innerHeight - r.bottom)) + 'px';
}
function openMega(it) {
clearTimeout(DK.openTimer);
clearTimeout(DK.closeTimer);
if (DK.open === it) return;
if (DK.open) closeMega(false);
warmMega(it);
it.panel.hidden = false;
placeMega(it);
it.btn.setAttribute('aria-expanded', 'true');
it.li.classList.add('is-open');
DK.open = it;
DKT.at = now();
DK.scrollY = window.pageYOffset;
}
function closeMega(returnFocus) {
clearTimeout(DK.openTimer);
clearTimeout(DK.closeTimer);
var it = DK.open;
if (!it) return;
it.panel.hidden = true;
it.btn.setAttribute('aria-expanded', 'false');
it.li.classList.remove('is-open');
DK.open = null;
if (returnFocus) it.btn.focus();
}
function focusables(panel) {
return panel.querySelectorAll('a[href], button');
}
function bindDesktop() {
DK.items.forEach(function (it) {
it.li.addEventListener('mouseenter', function () {
if (Date.now() - DK.touchAt < 800) return;
clearTimeout(DK.closeTimer);
warmMega(it);
if (DK.open && DK.open !== it) { openMega(it); return; }
if (DK.open === it) return;
clearTimeout(DK.openTimer);
DK.openTimer = setTimeout(function () { openMega(it); }, 60);
});
it.li.addEventListener('mouseleave', function () {
if (Date.now() - DK.touchAt < 800) return;
clearTimeout(DK.openTimer);
if (DK.open === it) DK.closeTimer = setTimeout(function () { closeMega(false); }, 200);
});
it.btn.addEventListener('click', function (e) {
var viaMouse = e.detail > 0 && Date.now() - DK.touchAt > 800;
if (it.btn.tagName === 'A') {
if (!viaMouse && e.detail > 0 && DK.open !== it) {
e.preventDefault();
openMega(it);
}
return;
}
if (DK.open === it) {
if (!viaMouse) closeMega(false);
} else {
openMega(it);
}
});
it.btn.addEventListener('keydown', function (e) {
var visible = DK.items.filter(function (x) { return !x.li.hidden; });
var vi = visible.indexOf(it);
if (vi < 0) vi = 0;
var n = visible.length, next = -1;
if (e.key === 'ArrowRight') next = (vi + 1) % n;
else if (e.key === 'ArrowLeft') next = (vi - 1 + n) % n;
else if (e.key === 'Home') next = 0;
else if (e.key === 'End') next = n - 1;
if (next >= 0) {
e.preventDefault();
if (DK.open) openMega(visible[next]);
visible[next].btn.focus();
return;
}
if (e.key === 'ArrowDown') {
e.preventDefault();
openMega(it);
var f = focusables(it.panel);
if (f.length) f[0].focus();
}
});
it.li.addEventListener('focusout', function (e) {
if (DK.open === it && e.relatedTarget && !it.li.contains(e.relatedTarget)) closeMega(false);
});
});
var linkLis = DK.bar.querySelectorAll('.civ3-dk-item--link');
for (var li = 0; li < linkLis.length; li++) {
linkLis[li].addEventListener('mouseenter', function () {
clearTimeout(DK.openTimer);
if (DK.open) closeMega(false);
});
}
DK.bar.addEventListener('keydown', function (e) {
if (!DK.open || !DK.open.panel.contains(e.target)) return;
if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
var f = Array.prototype.slice.call(focusables(DK.open.panel));
var i = f.indexOf(e.target);
if (i < 0) return;
e.preventDefault();
if (e.key === 'ArrowDown') f[Math.min(i + 1, f.length - 1)].focus();
else if (i === 0) DK.open.btn.focus();
else f[i - 1].focus();
});
doc.addEventListener('keydown', function (e) {
if ((e.key === 'Escape' || e.key === 'Esc') && DK.open) {
var inside = DK.open.li.contains(doc.activeElement);
closeMega(inside);
}
});
doc.addEventListener('click', function (e) {
if (DK.open && !DK.open.li.contains(e.target)) closeMega(false);
});
window.addEventListener('pointerdown', function (e) {
if (e.pointerType && e.pointerType !== 'mouse') DK.touchAt = Date.now();
}, { capture: true, passive: true });
window.addEventListener('scroll', function () {
if (DK.open && Math.abs(window.pageYOffset - DK.scrollY) > 60) closeMega(false);
}, { passive: true });
window.addEventListener('resize', function () {
if (DK.open) closeMega(false);
});
}
var guardedBuildDesktop = guard(buildDesktop, 'desktop', undoDesktop);
function onMenuIntent(e) {
var t = e.target;
if (!t || !t.closest) return;
var s = t.closest('summary.header__icon--menu');
if (!s || !s.closest('header-drawer')) return;
if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
TK.intentAt = now();
if (!DR.built && drawerHost() && drawerReady()) guardedBuildDrawer();
if (DR.built) {
applySlots();
hydrateDrawer();
}
}
['touchstart', 'pointerdown', 'mousedown', 'keydown', 'click'].forEach(function (type) {
window.addEventListener(type, onMenuIntent, { capture: true, passive: true });
});
whenReady(drawerReady, guardedBuildDrawer);
whenReady(desktopReady, guardedBuildDesktop);
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', applySlots);
if (!SALE_QA && SALE.enabled === true && SALE_END > Date.now() && SALE_END - Date.now() < 2147000000) {
setTimeout(applySlots, SALE_END - Date.now() + 1000);
}
if (!GIFTS_QA && GIFTS.enabled === true) {
if (GIFTS_START > Date.now() && GIFTS_START - Date.now() < 2147000000) {
setTimeout(applySlots, GIFTS_START - Date.now() + 1000);
}
if (GIFTS_END > Date.now() && GIFTS_END - Date.now() < 2147000000) {
setTimeout(applySlots, GIFTS_END - Date.now() + 1000);
}
}
})();
